export default {"src":"/_next/static/media/Grow Logo.709c993c.svg","height":40,"width":136};